import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'pickup-asap',
  styleUrls: ['./pickup-asap.component.scss'],
  template: `
    <div class="pa-container">
      <div>
        <div class="pa-title-desktop"
             [translate]="'bakerySite.expressOrdering.common.asapFull'">
          As soon as possible
        </div>

        <!--    <div class="pa-title-mobile">Pick up as soon as possible</div>-->

        <div class="mt-2 pa-confirm-btn-wrap">
          <button class="btn {{ nextBtnView }} pa-confirm-btn"
                  type="button"
                  (click)="confirm.emit()">
            {{ 'bakerySite.expressOrdering.common.todayAt' | translate: { time: time } }}
          </button>
        </div>
      </div>

      <div class="ms-5 d-none d-md-block" *ngIf="price">
        <div class="pa-title-desktop"
             [translate]="'orderProcess.delivery.deliveryForms.deliveryPrice'">
          Delivery price
        </div>

        <div class="pa-asap-price mt-2 fw-bold">
          {{ price }}
        </div>
      </div>
    </div>

    <div class="pa-or-later-wrap my-3">
      <div class="border-bottom-1 flex-grow-1"></div>
      <div class="pa-or-later" [translate]="'bakerySite.expressOrdering.common.orLater'">...or later</div>
      <div class="border-bottom-1 flex-grow-1"></div>
    </div>
  `
})
export class PickupAsapComponent implements OnInit {
  @Input() time: string;
  @Input() price: string;
  @Input() nextBtnView = 'btn-pink';
  @Output() confirm = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

}
